import type { ApolloError } from '@apollo/client';

export default function getIsNameAlreadyExistsError(error: ApolloError) {
  return error.graphQLErrors.some((err) => {
    const details = err.extensions?.details as { code: string } | { code: string }[] | undefined;
    if (!details) return false;
    if (Array.isArray(details)) {
      return details.some((detail) => detail.code === 'NAME_ALREADY_EXISTS');
    }
    return details.code === 'NAME_ALREADY_EXISTS';
  });
}
